import axios from '@/utils/axiosHelper';
import * as otherAxios from 'axios';
// 初始化数据(含授权)
export const onGetInitDataAPI = (params) => {
    return axios({ url: '/cherry/avatar/init', method: 'GET', params }, { interceptResultCode: false });
};

// 上传图片
export const uploadAPI = params => {
    return axios({ url: "/snail/upload", method: "POST", params }, { interceptResultCode: false });
};

// 上传头像
export const uploadPicAPI = params => {
    return axios({ url: "/cherry/avatar/send", method: "POST", params }, { interceptResultCode: false });
};

// 获取角色列表
export const GetRoleList = (params) => {
    return otherAxios({ url: `//api.qingcigame.com/game/server`, method: 'GET', params });
};


// WEBPACK FOOTER //
// ./src/pages/sakura/portrait/api.js